import { AnyAction } from 'redux';

const SET_SELECTED_SITE = 'SET_SELECTED_SITE';

export async function setSelectedSite(dispatch: any, site: string) {
  dispatch({
    type: SET_SELECTED_SITE,
    data: site
  });
}

const initialState = { selectedsite: '' };

const selectedsiteReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case SET_SELECTED_SITE: {
      return {
        ...state,
        selectedsite: action.data
      };
    }

    default:
      return state;
  }
};

export default selectedsiteReducer;
